import { Route } from "react-router-dom";
import {
  AdminAssets,
  AdminMenuTable,
  Agency,
  GetTraineeList,
  LeaveTypesTable,
  PracticalQuestions,
  Profile,
  Questions,
  Ratings,
  Reports,
  RoleTable,
  SessionDetails,
  Settings,
  UsersTable,
} from "../pages";
import DesigTable from "../pages/admin/DesigTable";
import HolidayTable from "../pages/admin/HolidayTable";
import LocationTable from "../pages/admin/LocationTable";
import SalaryComponentsTable from "../pages/admin/SalaryComponentsTable";
import DashBoardAdmin from "../pages/Home/DashBoardAdmin";
import DashboardTrainer from "../pages/Home/DashboardTrainer";
import Sessions from "../pages/sessions/Sessions";
import TrainersTable from "../pages/Users/TrainersTable";
import MainLayout from "../themes/Main/Layout";
import PrivateRoute from "./PrivateRoute";

const AdminRoutes = () => {
  return (
    <Route
      path="/admin/*"
      element={
        <PrivateRoute>
          <MainLayout />
        </PrivateRoute>
      }
    >
      {/* <Route path="dashboard" element={<DashBoardUser />} /> */}
      <Route path="dashboard-trainer" element={<DashboardTrainer />} />
      <Route path="dashboard-admin" element={<DashBoardAdmin />} />
      <Route path="role-list" element={<RoleTable />} />
      <Route path="user-list" element={<UsersTable />} />
      <Route path="trainer-list" element={<TrainersTable />} />
      <Route path="salary-components" element={<SalaryComponentsTable />} />
      <Route path="designations" element={<DesigTable />} />
      <Route path="site-settings" element={<Settings />} />
      <Route path="leave_types" element={<LeaveTypesTable />} />
      <Route path="locations" element={<LocationTable />} />
      <Route path="holidays" element={<HolidayTable />} />
      <Route path="profile" element={<Profile />} />
      <Route path="assets" element={<AdminAssets />} />
      <Route path="menu-settings" element={<AdminMenuTable />} />
      <Route path="questions" element={<Questions />} />
      <Route path="agency" element={<Agency />} />
      <Route path="reports" element={<Reports />} />{" "}
      <Route path="session/:id" element={<SessionDetails />} />
      <Route path="sessions" element={<Sessions />} />
      <Route path="sessions/:type" element={<Sessions />} />
      <Route path="trainee-list" element={<GetTraineeList />} />{" "}
      <Route path="ratings" element={<Ratings />} /> 
        <Route path="practical" element={<PracticalQuestions />} /> 
    </Route>
  );
};

export default AdminRoutes;
